<template>
    <v-speed-dial direction="left" open-on-click>
        <template v-slot:activator>
            <v-btn dark small block color="info">
                <v-icon>mdi-menu-open</v-icon>
            </v-btn>
        </template>
        <dyn-btn
            v-for="(btn, index) in btns"
            :key="index"
            :btn="btn"
            :parameter="item"
            @trigger:btn="triggerBtn(btn, item)"
        />
    </v-speed-dial>
</template>

<script>
import DynBtn from './DynBtn.vue';
export default {
    name: 'DynamicSpeedDial',
    props: {
        item: Object,
        editItemIcon: String
    },
    components: {
        DynBtn
    },
    data() {
        return {
            btns: [
                {
                    icon: 'mdi-table-arrow-down',
                    color: 'teal',
                    tooltip: 'Download Report',
                    emit: 'download:item-report',
                    dark: true
                },
                {
                    icon: 'mdi-delete',
                    color: 'error',
                    tooltip: 'Delete',
                    emit: 'delete:item',
                    dark: true
                },
                {
                    icon: 'mdi-invoice-edit',
                    color: 'indigo',
                    tooltip: 'Edit',
                    emit: 'edit:item',
                    dark: true
                } /*
                {
                    icon: 'mdi-open-in-new',
                    color: 'info',
                    tooltip: 'View',
                    emit: 'view:item',
                    dark: true
                }*/
            ]
        };
    },
    methods: {
        triggerBtn(btn, parameter) {
            console.log('DynamicSpeedDial triggerBtn: ', btn, parameter);
            this.$emit(btn.emit, parameter);
        }
    }
};
</script>
